export const SESSION_REPLAY_SAMPLE_PERCENT = 0;

export const SESSION_REPLAY_BLOCK_SELECTORS = [
  'img',
  'video',
  'audio',
  '.c-radiogroup',
  '.c-radio',
  '.pac-container',
  '.rg-select',
] as const;

export const SESSION_REPLAY_MASK_TEXT_SELECTORS = [
  '.wreg-mask-ghost',
  '.wreg-mbi-ghost',
] as const;
